module.exports = __webpack_public_path__ + "img/printer.d97c7a48.svg";